<template>
  <section
    class="container"
  >
    <ListLoading v-if="loading" />
    <div
      v-else
      class="testimonials"
    >
      <div class="section-head">
        <h2 class="section-title">
          Testimonials
        </h2>
        <!-- <router-link
          to="/AllTestimonials"
          class="navigator"
        >
          view all testimonials 🡢<i class="icon" />
        </router-link> -->
      </div>
      <!--
          vueper-slides wrapper to each slider cards
          vueper-slide represents each testimonials cards
          @see See [Documentation Link](https://antoniandre.github.io/vueper-slides/).
      -->
      <vueper-slides
        class="no-shadow"
        autoplay
        :visible-slides="2"
        :duration="4000"
        :gap="6"
        :arrows="false"
        :dragging-distance="200"
        :breakpoints="{ 768: { visibleSlides: 1, slideMultiple: 1, bullets: false } }"
      >
        <vueper-slide
          v-for="testimonial in testimonials"
          :key="testimonial.id"
          class="card"
        >
          <template #content>
            <div class="quote-icon">
              <i class="icon">❝</i>
            </div>
            <p class="card-desc">
              {{ textTrimer(testimonial.description, 200) }}
            </p>
            <div class="profile-container">
              <div class="avatar">
                <img
                  :src="testimonial.image.url"
                  alt=""
                >
              </div>

              <div class="profile-info">
                <h4 class="name">
                  {{ testimonial.name }}
                </h4>
                <h5 class="position">
                  {{ testimonial.title }}
                </h5>
                <!-- TODO(saroj) : Need to uncomment this when rating feature is added -->
                <!-- <div class="rating">
                  <i class="icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        cx="12"
                        cy="12"
                        r="12"
                        fill="#0629a9"
                      />
                      <path
                        d="M9.316,12.644,13.219,15l-1.036-4.44,3.448-2.987-4.541-.385L9.316,3,
                      7.541,7.187,3,7.573,6.448,10.56,5.413,15Z"
                        transform="translate(2.684 3)"
                        fill="#fff"
                      /></svg>
                  </i>
                  4.9
                </div> -->
              </div>
            </div>
          </template>
        </vueper-slide>
      </vueper-slides>
    </div>
  </section>
</template>

<script>
import {VueperSlides, VueperSlide} from 'vueperslides'
import 'vueperslides/dist/vueperslides.css'
import ListLoading from '@/components/LoadingAnimations/ListLoading.vue'
import {textTrimer} from '@/utils/common'
import {useTestimonialStore} from '@/store'
import {onMounted, computed} from 'vue'

export default {
  components: {
    VueperSlides,
    VueperSlide,
    ListLoading,
  },
  setup() {
    const testimonialStore = useTestimonialStore()

    onMounted(async () => {
      await testimonialStore.getAllTestimonials()
    })

    const loading = computed(() => testimonialStore.loading)
    const testimonials = computed(() => testimonialStore.getSlicedTestimonials)

    return {
      testimonials,
      loading,
      textTrimer,
    }
  },
}
</script>
<style lang="scss">
  @import '@/sass/module/home_testimonials';
</style>
